module.exports = __webpack_public_path__ + "img/btn_google_light_pressed_ios.ebc8aa49.svg";